angular.module('eStories.terms', [
    'eStories.account.model'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.terms', {
                url: 'terms',
                views: {
                    'mainView@': {
                        templateUrl: 'terms/terms.tmpl.html',
                        controller: 'TermsCtrl as termsCtrl'
                    }
                }
            });
    }])

    .controller('TermsCtrl',
        [
            'AccountModel',
            '$scope',
            'GA',
            '$location',
            function (AccountModel, $scope, GA, $location) {
                var termsCtrl = this;

                GA.trackPageView($location.path());

                AccountModel.getLocation().then(function (response) {
                    if (response == null || response.responseStatus !== "SUCCESS") {
                        return;
                    }
                    termsCtrl.countryCode = response.country.code;
                    termsCtrl.USandCA = termsCtrl.countryCode === 'US' || termsCtrl.countryCode === 'CA';
                    safeApply($scope);
                });

            }
        ]
    );
